<template>
  <div class="product-form-container">
    <!-- 全局加载遮罩层 -->
    <div class="loading-mask" v-if="loading">
      <div class="loading-spinner"></div>
    </div>
    <!-- 表单主体 -->
    <div class="form-wrapper">
      <h1 class="panel-title">官方产样修改</h1>
      <!-- 左侧表单区域 -->
      <div class="form-left">
        <!-- 样衣编号 -->
        <div class="form-item single-item">
          <label>样衣编号:</label>
          <input
            style="width: 150px"
            type="text"
            v-model="formData.productCode"
            placeholder="请输入样衣编号"
            disabled
          />
          <label>类别:</label>
          <el-select
            v-model="formData.categoryId"
            placeholder="请选择类别"
            multiple
            collapse-tags
            clearable
            style="padding: 12px"
            :style="{ borderBottom: 'none' }"
          >
            <el-option
              v-for="option in leilist"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            />
          </el-select>
        </div>
        <!-- 面料信息分组 -->
        <div class="fabric-group">
          <div class="group-title">面料信息：</div>
          <div class="form-item single-item">
            <label>品名/编号:</label>
            <el-select
              v-model="formData.productpm"
              placeholder="请选择品名编号"
              filterable
              @change="watchs(formData.productpm)"
              style="padding: 12px"
              :style="{ borderBottom: 'none' }"
            >
              <el-option
                v-for="option in lists"
                :key="option.id"
                :label="option.name"
                :value="option.name"
              />
            </el-select>
          </div>
          <!-- 两行两列布局：幅宽/克重、成份/类别 -->
          <div class="form-row">
            <div class="form-item">
              <label>幅宽:</label>
              <input disabled type="text" v-model="formData.width" />
            </div>
            <div class="form-item">
              <label>克重:</label>
              <input disabled type="text" v-model="formData.weight" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>成份:</label>
              <input disabled type="text" v-model="formData.composition" />
            </div>
            <div class="form-item">
              <label>规格:</label>
              <input disabled type="text" v-model="formData.specification" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>量化:</label>
              <input disabled type="text" v-model="formData.quantify" />
            </div>
            <div class="form-item">
              <label>备注:</label>
              <input disabled type="text" v-model="formData.remark" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>纱支:</label>
              <input disabled type="text" v-model="formData.yarnCount" />
            </div>
            <div class="form-item">
              <label>密度:</label>
              <input disabled type="text" v-model="formData.density" />
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧上传区域 -->
      <div class="form-right">
        <!-- 封面图上传 - 单个 -->
        <div class="upload-section">
          <h4>封面图（图片比例宽高3:4，单张图片不能超过1MB）</h4>
          <div class="upload-boxes">
            <div
              class="upload-box"
              style="width: 130px; height: 120px"
              @click="handleUpload('cover', null)"
            >
              <img
                v-if="previewUrls['cover'] && !deletedCover"
                :src="previewUrls['cover']"
                class="uploaded-img"
                @click.stop="openCoverAnnotate"
              />
              <div
                v-if="previewUrls['cover'] && !deletedCover"
                class="img-mask-edit"
              >
                <div
                  class="mask-btn"
                  @click.stop="openImagePreview(previewUrls['cover'])"
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                  >
                    <path
                      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    ></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span class="edit-tip-text">预览</span>
                </div>
                <div class="mask-btn" @click.stop="handleUpload('cover', null)">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#61b88e"
                    stroke-width="2"
                  >
                    <path d="M12 20h9"></path>
                    <path
                      d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                    ></path>
                  </svg>
                  <span class="edit-tip-text">修改</span>
                </div>
                <!-- 新增标注按钮 -->
                <div class="mask-btn" @click.stop="openCoverAnnotate">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#409eff"
                    stroke-width="2"
                  >
                    <path
                      d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                    ></path>
                  </svg>
                  <span class="edit-tip-text">标注</span>
                </div>
              </div>
              <div
                v-if="previewUrls['cover']"
                class="img-delete-btn"
                @click.stop="handleDeleteImage('cover', null)"
              >
                ×
              </div>
              <span v-else>+</span>
            </div>
          </div>
        </div>
        <!-- 详情图上传 -->
        <div class="upload-section">
          <h4>详情图(上限5张，单张图片不能超过1MB)</h4>
          <div class="upload-container">
            <!-- 新增按钮 -->
            <div
              class="add-btn upload-box"
              @click="handleUpload('detail', null)"
              v-if="validDetails.length < 5"
            >
              <span>+</span>
            </div>
            <!-- 图片展示区（保留原有样式结构） -->
            <div class="img-show-wrap">
              <!-- 显示未删除的图片 -->
              <div
                class="upload-box img-item"
                v-for="item in validDetails"
                :key="`detail-${item._uid}`"
                draggable="true"
                @dragstart="handleDragStart($event, item, 'detail')"
                @dragover.prevent
                @drop="handleDrop($event, item, 'detail')"
                @click="handleUpload('detail', item)"
              >
                <img :src="item.url" class="uploaded-img" />
                <div class="img-mask-edit">
                  <div
                    class="mask-btn"
                    @click.stop="openImagePreview(item.url)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span class="edit-tip-text">预览</span>
                  </div>
                  <div
                    class="mask-btn"
                    @click.stop="handleUpload('detail', item)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#61b88e"
                      stroke-width="2"
                    >
                      <path d="M12 20h9"></path>
                      <path
                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                      ></path>
                    </svg>
                    <span class="edit-tip-text">修改</span>
                  </div>
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('detail', item)"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子色卡上传 -->
        <div class="upload-section">
          <h4>电子色卡(上限5张，单张图片不能超过1.3MB)</h4>
          <div class="upload-container">
            <!-- 新增按钮 -->
            <div
              class="add-btn upload-box"
              @click="handleUpload('color', null)"
              v-if="validColors.length < 5"
            >
              <span>+</span>
            </div>
            <!-- 图片展示区（保留原有样式结构） -->
            <div class="img-show-wrap">
              <!-- 显示未删除的图片 -->
              <div
                class="upload-box img-item"
                v-for="item in validColors"
                :key="`color-${item._uid}`"
                draggable="true"
                @dragstart="handleDragStart($event, item, 'color')"
                @dragover.prevent
                @drop="handleDrop($event, item, 'color')"
                @click="handleUpload('color', item)"
              >
                <img :src="item.url" class="uploaded-img" />
                <div class="img-mask-edit">
                  <div
                    class="mask-btn"
                    @click.stop="openImagePreview(item.url)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span class="edit-tip-text">预览</span>
                  </div>
                  <div
                    class="mask-btn"
                    @click.stop="handleUpload('color', item)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#61b88e"
                      stroke-width="2"
                    >
                      <path d="M12 20h9"></path>
                      <path
                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                      ></path>
                    </svg>
                    <span class="edit-tip-text">修改</span>
                  </div>
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('color', item)"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题和正文输入区 -->
      <div class="textarea-section">
        <div class="textarea-item">
          <label>标题</label>
          <textarea
            v-model="formData.title"
            placeholder="请输入标题,字数不能超过45个字"
            maxlength="45"
          ></textarea>
        </div>
        <div class="textarea-item">
          <label>正文</label>
          <textarea
            v-model="formData.content"
            placeholder="请输入正文,字数不能超过150个字"
            rows="6"
            maxlength="150"
          ></textarea>
        </div>
      </div>
      <!-- 按钮组 -->
      <div class="btn-group">
        <button
          class="btn publish-btn"
          @click="handleUpdate"
          :disabled="loading"
        >
          保存修改
        </button>
        <button class="btn save-btn" @click="handleCancel">取消</button>
      </div>
      <!-- 替换为 element‑plus el‑image‑viewer -->
      <el-image-viewer
        v-if="previewVisible"
        :url-list="[previewImageUrl]"
        :initial-index="0"
        @close="closePreview"
      />
    </div>
    <!-- 封面图放大标注弹窗【和发布页面一模一样】 -->
    <el-dialog
      v-model="coverAnnotateVisible"
      title="封面图标注"
      width="90%"
      append-to-body
      @closed="clearCanvasInstance"
    >
      <div style="display: flex; gap: 16px">
        <!-- 左侧画布区域 -->
        <div
          ref="canvasWrapRef"
          class="canvas-wrap"
          style="
            flex: 1;
            height: 600px;
            overflow: hidden;
            position: relative;
            background: #f5f5f5;
          "
        >
          <canvas ref="coverCanvas" @click="handleCanvasClick"></canvas>
          <div
            v-if="coverMarkList.length"
            style="
              position: absolute;
              top: 8px;
              left: 8px;
              background: rgba(0, 0, 0, 0.55);
              color: #fff;
              font-size: 12px;
              padding: 4px 8px;
              border-radius: 4px;
              pointer-events: none;
            "
          >
            已标注 {{ coverMarkList.length }} 个点
          </div>
        </div>
        <!-- 右侧：标注类型 + 坐标列表面板 -->
        <div
          style="
            width: 260px;
            flex-shrink: 0;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            padding: 12px;
            display: flex;
            flex-direction: column;
          "
        >
          <div style="margin-bottom: 12px">
            <div style="font-size: 14px; margin-bottom: 8px">选择标注类型</div>
            <el-radio-group v-model="currentMarkType">
              <el-radio label="fabric">面料供应点</el-radio>
              <el-radio label="accessory">辅料供应点</el-radio>
            </el-radio-group>
          </div>
          <div style="flex: 1; overflow: auto">
            <div style="font-size: 14px; margin-bottom: 8px; font-weight: 500">
              标注坐标列表
            </div>
            <div
              v-if="!coverMarkList.length"
              style="color: #999; font-size: 12px"
            >
              暂无标注点
            </div>
            <div
              v-for="(item, idx) in coverMarkList"
              :key="idx"
              style="
                padding: 6px 0;
                border-bottom: 1px solid #eee;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="font-size: 12px">
                <span
                  >{{ idx + 1 }}.
                  {{
                    item.type === "fabric" ? "面料供应点" : "辅料供应点"
                  }}</span
                >
                <br />
                <span style="color: #666">X:{{ item.x }} Y:{{ item.y }}</span>
              </div>
              <el-button
                size="small"
                type="danger"
                text
                @click="removeSingleMark(idx)"
                >删除</el-button
              >
            </div>
          </div>
          <div style="margin-top: 12px; display: flex; gap: 8px">
            <el-button size="small" @click="clearCoverMarks"
              >清空全部</el-button
            >
            <el-button
              size="small"
              class="btn publish-btn"
              @click="coverAnnotateVisible = false"
              >确定保存</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="annotate-toolbar"
        style="margin-top: 12px; display: flex; gap: 10px; align-items: center"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ElSelect,
  ElOption,
  ElImageViewer,
  ElRadioGroup,
  ElRadio,
} from "element-plus";
export default {
  name: "ProductEditForm",
  components: { ElSelect, ElOption, ElImageViewer, ElRadioGroup, ElRadio },
  props: {
    row: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      lists: [],
      leilist: [],
      loading: false,
      localRow: {},
      dragItem: null, //拖拽临时数据
      // 大图预览【新增】
      previewVisible: false,
      previewImageUrl: "",
      MAX_COVER_SIZE: 1024 * 1024, //封面1MB
      MAX_IMG_SIZE: 1024 * 1024, //详情图1MB
      MAX_COLORCARD_SIZE: 1.3 * 1024 * 1024, //电子色卡1.3MB
      formData: {
        id: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
        productpm: "",
        specification: "",
        yarnCount: "",
        density: "",
        quantify: "",
        remark: "",
      },
      uploadFiles: {}, // key 使用图片 _uid，封面固定key:'cover'
      previewUrls: {},
      deletedCover: false,
      details: [], // 统一管理详情图（原有+新增）
      colors: [], // 统一管理色卡图（原有+新增）

      // ========== 封面标注 新增变量（和发布页完全一致） ==========
      coverAnnotateVisible: false,
      coverImgObj: null,
      coverScale: 1,
      coverTranslateX: 0,
      coverTranslateY: 0,
      coverIsDragging: false,
      coverLastX: 0,
      coverLastY: 0,
      coverMarkList: [],
      currentMarkType: "fabric",
      coverImageWidth: null,
      coverImageHeight: null,
    };
  },
  computed: {
    // 过滤未删除的详情图（用于展示）
    validDetails() {
      return this.details.filter((item) => !item.deleted);
    },
    // 过滤未删除的色卡图（用于展示）
    validColors() {
      return this.colors.filter((item) => !item.deleted);
    },
  },
  mounted() {
    this.getcp();
    this.getCategoryList().then(() => this.initEditData());
  },
  watch: {
    row: {
      handler(n) {
        if (n && n.id) {
          this.resetForm();
          this.initEditData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // ========== 大图预览两个方法，适配el‑image‑viewer ==========
    openImagePreview(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    },
    closePreview() {
      this.previewVisible = false;
      this.previewImageUrl = "";
    },
    // ✅只重写sort，不去动uploadFiles，参考样衣组件
    normalizeSort(type) {
      let arr;
      if (type === "detail") arr = this.details;
      else if (type === "color") arr = this.colors;
      else return;
      arr.forEach((item, idx) => {
        item.sort = idx + 1;
      });
    },
    handleDragStart(e, item, type) {
      this.dragItem = { item, type };
      e.dataTransfer.effectAllowed = "move";
    },
    handleDrop(e, targetItem, type) {
      e.preventDefault();
      if (!this.dragItem || this.dragItem.type !== type) return;
      const sourceItem = this.dragItem.item;
      if (sourceItem === targetItem) {
        this.dragItem = null;
        return;
      }
      let list;
      if (type === "detail") list = this.details;
      else if (type === "color") list = this.colors;
      else {
        this.dragItem = null;
        return;
      }
      const sourceIndex = list.findIndex((x) => x === sourceItem);
      const targetIndex = list.findIndex((x) => x === targetItem);
      list.splice(sourceIndex, 1);
      list.splice(targetIndex, 0, sourceItem);
      this.normalizeSort(type);
      this.dragItem = null;
    },
    watchs(item) {
      const cpname = item;
      const itemlist = this.lists.filter((item) => item.name == cpname);
      this.formData.width = itemlist[0].width;
      this.formData.weight = itemlist[0].weight;
      this.formData.composition = itemlist[0].ingredients;
      this.formData.quantify = itemlist[0].quantify;
      this.formData.remark = itemlist[0].remark;
      this.formData.yarnCount = itemlist[0].yarnCount;
      this.formData.density = itemlist[0].density;
      this.formData.specification = itemlist[0].specification;
    },
    //获取面料信息
    async getcp() {
      const sendata = `name=${encodeURIComponent(
        ""
      )}&memberName=${encodeURIComponent(
        ""
      )}&memberProductName=${encodeURIComponent("")}`;
      const res = await this.$api.Operation.Baseproduct.get(sendata);
      if (res.data.code == "200") {
        this.lists = res.data.data.list;
      } else {
        this.$message.error("网络错误");
        this.lists = [];
      }
    },
    // 补全图片URL协议
    completeUrlProtocol(url) {
      if (!url || typeof url !== "string") return "";
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    // 获取分类列表
    async getCategoryList() {
      try {
        const res = await this.$api.System.ProductCategory.get({});
        if (res.data.code == 200 && Array.isArray(res.data.data?.list)) {
          this.leilist = res.data.data.list.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        } else {
          this.$message.error("获取类别列表失败");
        }
      } catch (error) {
        console.error("获取类别列表失败：", error);
        this.$message.error("网络错误，获取类别列表失败");
      }
    },
    // 初始化编辑数据【重点：解析后端坐标回显】
    initEditData() {
      const d = this.row;
      if (!d) return;
      // 初始化本地副本
      this.localRow = JSON.parse(JSON.stringify(d));
      // 初始化详情图数组（原有图片），增加_uid唯一标识用于拖拽key
      this.details = (this.localRow.particularsList || []).map((item) => ({
        _uid: Date.now() + Math.random(),
        id: item.id, // 原有图片ID
        sort: item.sort,
        url: this.completeUrlProtocol(item.url),
        isNew: false, // 标记是否为新增图片
        deleted: false, // 删除标记
      }));
      // 初始化色卡图数组（原有图片），增加_uid唯一标识用于拖拽key
      this.colors = (this.localRow.colorcardList || []).map((item) => ({
        _uid: Date.now() + Math.random(),
        id: item.id,
        sort: item.sort,
        url: this.completeUrlProtocol(item.url),
        isNew: false,
        deleted: false,
      }));
      // 基础表单数据
      this.formData = {
        id: d.id || "",
        productCode: d.outerKey || "",
        width: d.width || "",
        weight: d.weight || "",
        composition: d.ingredients || "",
        categoryId: (d.categoryList || []).map((item) => item.id),
        title: d.title || "",
        content: d.content || "",
        productpm: d.name || "",
        specification: d.specification || "",
        quantify: d.quantify || "",
        yarnCount: d.yarnCount || "",
        density: d.density || "",
        remark: d.remark || "",
      };
      // 封面图
      if (d.coverUrl) {
        this.previewUrls["cover"] = this.completeUrlProtocol(d.coverUrl);
      }
      this.deletedCover = false;

      // ========== 解析后端返回坐标字符串，回显标注点位 ==========
      this.coverMarkList = [];
      // coverFabricCoordinates: "[{\"x\":270,\"y\":106}]"
      if (d.coverFabricCoordinates) {
        try {
          const fabricArr = JSON.parse(d.coverFabricCoordinates);
          fabricArr.forEach((p) => {
            this.coverMarkList.push({
              x: p.x,
              y: p.y,
              type: "fabric",
            });
          });
        } catch (e) {
          console.warn("面料坐标解析失败", e);
        }
      }
      // coverAccessoryCoordinates: "[{\"x\":248,\"y\":294}]"
      if (d.coverAccessoryCoordinates) {
        try {
          const accArr = JSON.parse(d.coverAccessoryCoordinates);
          accArr.forEach((p) => {
            this.coverMarkList.push({
              x: p.x,
              y: p.y,
              type: "accessory",
            });
          });
        } catch (e) {
          console.warn("辅料坐标解析失败", e);
        }
      }
      // 原图宽高
      this.coverImageWidth = d.coverWidth || null;
      this.coverImageHeight = d.coverHeight || null;
    },
    /**
     * @param {String} type cover/detail/color
     * @param {Object|null} payload null=新增；item对象=修改已有图片
     */
    handleUpload(type, payload) {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      // 只有详情/色卡开启多选，封面保持单选
      if (type === "detail" || type === "color") {
        fileInput.multiple = true;
      }
      fileInput.style.display = "none";
      fileInput.onchange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;
        // ========= 封面（仍然只允许选一张） =========
        if (type === "cover") {
          const file = files[0];
          if (!file.type.startsWith("image/")) {
            this.$message.error("请选择图片格式文件！");
            document.body.removeChild(fileInput);
            return;
          }
          let limitSize = this.MAX_COVER_SIZE;
          let errMsg = "图片大小不能超过1MB";
          if (file.size > limitSize) {
            this.$message.error(errMsg);
            document.body.removeChild(fileInput);
            return;
          }
          const blobUrl = URL.createObjectURL(file);
          this.uploadFiles["cover"] = file;
          this.previewUrls["cover"] = blobUrl;
          this.deletedCover = false;
          // 读取新上传封面的原图宽高
          const img = new Image();
          img.src = blobUrl;
          img.onload = () => {
            this.coverImageWidth = img.width;
            this.coverImageHeight = img.height;
          };
          document.body.removeChild(fileInput);
          return;
        }
        // ========= 详情 / 电子色卡 支持批量多选 =========
        let targetList = type === "detail" ? this.details : this.colors;
        const maxCount = 5;
        // 当前有效未删除图片数量
        const validCount = targetList.filter((item) => !item.deleted).length;
        const availableNum = maxCount - validCount;
        if (availableNum <= 0) {
          this.$message.error(`最多只能上传${maxCount}张！`);
          document.body.removeChild(fileInput);
          return;
        }
        // 只取还能上传的数量，多余的直接丢弃
        const selectFiles = files.slice(0, availableNum);
        for (const file of selectFiles) {
          if (!file.type.startsWith("image/")) {
            this.$message.error(`文件${file.name}不是图片，已跳过`);
            continue;
          }
          let limitSize, errMsg;
          if (type === "color") {
            limitSize = this.MAX_COLORCARD_SIZE;
            errMsg = "图片大小不能超过1.3MB";
          } else {
            limitSize = this.MAX_IMG_SIZE;
            errMsg = "图片大小不能超过1MB";
          }
          if (file.size > limitSize) {
            this.$message.error(`${file.name}：${errMsg}，已跳过`);
            continue;
          }
          // 单张修改逻辑（payload有值代表修改已有图片，不支持多选修改）
          if (payload) {
            const blobUrl = URL.createObjectURL(file);
            payload.url = blobUrl;
            payload.isNew = true;
            payload.deleted = false;
            this.uploadFiles[payload._uid] = file;
            break; // 修改模式，只处理第一个选中文件
          } else {
            // 新增图片
            const newUid = Date.now() + Math.random();
            const newItem = {
              _uid: newUid,
              id: "",
              sort: 1,
              url: URL.createObjectURL(file),
              isNew: true,
              deleted: false,
            };
            targetList.push(newItem);
            this.uploadFiles[newUid] = file;
          }
        }
        this.normalizeSort(type);
        document.body.removeChild(fileInput);
      };
      document.body.appendChild(fileInput);
      fileInput.click();
    },
    // 处理图片删除
    handleDeleteImage(type, item) {
      if (type === "cover") {
        this.deletedCover = true;
        if (this.previewUrls["cover"]) {
          URL.revokeObjectURL(this.previewUrls["cover"]);
          this.previewUrls["cover"] = "";
          // 删除封面同时清空坐标
          this.coverMarkList = [];
          this.coverImageWidth = null;
          this.coverImageHeight = null;
        }
      } else {
        item.deleted = true;
        if (item.url.startsWith("blob:")) {
          URL.revokeObjectURL(item.url);
        }
      }
    },
    // 构建提交的FormData
    buildSubmitFormData() {
      // ✅提交前强制校准sort，数组物理顺序与sort一一对应
      this.normalizeSort("detail");
      this.normalizeSort("color");
      const fd = new FormData();
      const d = this.localRow || {};

      // 基础信息
      fd.append("product.id", d.id || "");
      fd.append("product.outerKey", this.formData.productCode || "");
      fd.append("product.width", this.formData.width || "");
      fd.append("product.weight", this.formData.weight || "");
      fd.append("product.ingredients", this.formData.composition || "");
      this.formData.categoryId.forEach((item, index) => {
        fd.append(`product.categoryIds[${index}]`, item);
      });
      fd.append("product.title", this.formData.title || "");
      fd.append("product.quantify", this.formData.quantify || "");
      fd.append("product.remark", this.formData.remark || "");
      fd.append("product.yarnCount", this.formData.yarnCount || "");
      fd.append("product.density", this.formData.density || "");
      fd.append("product.specification", this.formData.specification || "");
      fd.append("product.content", this.formData.content || "");
      fd.append("product.name", this.formData.productpm || "");
      fd.append("product.flag", "0");

      // ========== 坐标提交（和发布页面完全一致） ==========
      if (this.coverMarkList && this.coverMarkList.length) {
        fd.append(
          "product.coverFabricCoordinates",
          JSON.stringify(
            this.coverMarkList
              .filter((item) => item.type === "fabric")
              .map((item) => ({
                x: item.x,
                y: item.y,
              }))
          )
        );
        fd.append(
          "product.coverAccessoryCoordinates",
          JSON.stringify(
            this.coverMarkList
              .filter((item) => item.type === "accessory")
              .map((item) => ({
                x: item.x,
                y: item.y,
              }))
          )
        );
      }
      // 原图宽高
      if (this.coverImageWidth != null) {
        fd.append("product.coverWidth", this.coverImageWidth);
      }
      if (this.coverImageHeight != null) {
        fd.append("product.coverHeight", this.coverImageHeight);
      }

      // 封面图
      if (this.uploadFiles["cover"]) {
        fd.append("product.coverFile", this.uploadFiles["cover"]);
      }
      fd.append("product.coverDelFlag", this.deletedCover ? "0" : "1");
      // 详情图（通过_uid拿file）
      let detailIdx = 0;
      this.details.forEach((item) => {
        const k = `particularsList[${detailIdx}]`;
        fd.append(`${k}.id`, item.id);
        fd.append(`${k}.sort`, item.sort);
        fd.append(`${k}.delflag`, item.deleted ? "0" : "1");
        if (this.uploadFiles[item._uid]) {
          fd.append(`${k}.file`, this.uploadFiles[item._uid]);
        }
        detailIdx++;
      });
      // 色卡图（通过_uid拿file）
      let colorIdx = 0;
      this.colors.forEach((item) => {
        const k = `colorcardList[${colorIdx}]`;
        fd.append(`${k}.id`, item.id);
        fd.append(`${k}.sort`, item.sort);
        fd.append(`${k}.delflag`, item.deleted ? "0" : "1");
        if (this.uploadFiles[item._uid]) {
          fd.append(`${k}.file`, this.uploadFiles[item._uid]);
        }
        colorIdx++;
      });
      return fd;
    },
    // 提交修改
    async handleUpdate() {
      // 表单校验
      if (!this.formData.productCode) {
        this.$message.error("产品编号为必填项！");
        return;
      }
      if (this.formData.categoryId.length == 0) {
        this.$message.error("类别为必填项！");
        return;
      }
      if (
        (!this.previewUrls["cover"] || this.deletedCover) &&
        !this.row.coverUrl
      ) {
        this.$message.error("封面图为必填项！");
        return;
      }
      this.loading = true;
      try {
        const fd = this.buildSubmitFormData();
        const res = await this.$api.Operation.UserProductlaunch.update(fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res.data.code == 200) {
          this.$message.success("修改成功！");
          this.$emit("update-success");
          this.resetForm();
        } else {
          this.$message.error(`修改失败：${res.data.msg || "接口返回异常"}`);
        }
      } catch (error) {
        console.error("修改失败：", error);
        this.$message.error(`修改失败：${error.message || "网络异常，请重试"}`);
      } finally {
        this.loading = false;
      }
    },
    // 取消修改
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    // 重置表单
    resetForm() {
      this.formData = {
        id: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
      };
      this.details = [];
      this.colors = [];
      this.uploadFiles = {};
      this.previewUrls = {};
      this.localRow = {};
      this.dragItem = null;
      this.deletedCover = false;
      // 释放Blob URL
      Object.keys(this.previewUrls).forEach((key) => {
        if (this.previewUrls[key]?.startsWith("blob:")) {
          URL.revokeObjectURL(this.previewUrls[key]);
        }
      });
      // 清空标注
      this.coverMarkList = [];
      this.coverImageWidth = null;
      this.coverImageHeight = null;
      this.coverAnnotateVisible = false;
    },

    // ====================== 下面全部复制发布页canvas标注方法 ======================
    openCoverAnnotate() {
      const src = this.previewUrls["cover"];
      if (!src) {
        this.$message.warning("请先上传封面图");
        return;
      }
      this.coverAnnotateVisible = true;
      this.$nextTick(() => {
        this.initCoverCanvas(src);
      });
    },
    initCoverCanvas(imgSrc) {
      const canvas = this.$refs.coverCanvas;
      const wrap = this.$refs.canvasWrapRef;
      if (!canvas || !wrap) return;
      const ctx = canvas.getContext("2d");
      this.coverCanvas = canvas;
      this.coverCtx = ctx;
      this.coverScale = 1;
      this.coverTranslateX = 0;
      this.coverTranslateY = 0;
      this.coverIsDragging = false;
      this.coverImgObj = new Image();
      this.coverImgObj.src = imgSrc;
      this.coverImgObj.onload = () => {
        canvas.width = wrap.clientWidth;
        canvas.height = wrap.clientHeight;
        const img = this.coverImgObj;
        // 如果后端带回宽高优先用后端，没有再用图片原生宽高
        if (!this.coverImageWidth) this.coverImageWidth = img.width;
        if (!this.coverImageHeight) this.coverImageHeight = img.height;

        const scale = Math.min(
          canvas.width / img.width,
          canvas.height / img.height
        );
        this.coverScale = scale;
        this.coverTranslateX = (canvas.width - img.width * scale) / 2;
        this.coverTranslateY = (canvas.height - img.height * scale) / 2;
        this.drawCoverCanvas();
      };
      canvas.onwheel = (e) => {
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const mx = e.clientX - rect.left;
        const my = e.clientY - rect.top;
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        const newScale = Math.max(0.2, Math.min(5, this.coverScale + delta));
        const ratio = newScale / this.coverScale;
        this.coverTranslateX = mx - (mx - this.coverTranslateX) * ratio;
        this.coverTranslateY = my - (my - this.coverTranslateY) * ratio;
        this.coverScale = newScale;
        this.drawCoverCanvas();
      };
      canvas.onmousedown = (e) => {
        this.coverIsDragging = true;
        this.coverLastX = e.clientX;
        this.coverLastY = e.clientY;
      };
      canvas.onmousemove = (e) => {
        if (!this.coverIsDragging) return;
        const dx = e.clientX - this.coverLastX;
        const dy = e.clientY - this.coverLastY;
        this.coverTranslateX += dx;
        this.coverTranslateY += dy;
        this.coverLastX = e.clientX;
        this.coverLastY = e.clientY;
        this.drawCoverCanvas();
      };
      canvas.onmouseup = () => {
        this.coverIsDragging = false;
      };
      canvas.onmouseleave = () => {
        this.coverIsDragging = false;
      };
    },
    drawCoverCanvas() {
      const canvas = this.coverCanvas;
      const ctx = this.coverCtx;
      const img = this.coverImgObj;
      if (!canvas || !ctx || !img) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      ctx.translate(this.coverTranslateX, this.coverTranslateY);
      ctx.scale(this.coverScale, this.coverScale);
      ctx.drawImage(img, 0, 0, img.width, img.height);
      // 区分两种点颜色：面料红色，辅料蓝色
      this.coverMarkList.forEach((mark) => {
        ctx.beginPath();
        ctx.arc(mark.x, mark.y, 6 / this.coverScale, 0, Math.PI * 2);
        ctx.fillStyle = mark.type === "fabric" ? "#f56c6c" : "#409eff";
        ctx.fill();
        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2 / this.coverScale;
        ctx.stroke();
      });
      ctx.restore();
    },
    handleCanvasClick(e) {
      if (this.coverIsDragging) return;
      const canvas = this.coverCanvas;
      const img = this.coverImgObj;
      if (!canvas || !img) return;
      const rect = canvas.getBoundingClientRect();
      const cx = e.clientX - rect.left;
      const cy = e.clientY - rect.top;
      const originX = (cx - this.coverTranslateX) / this.coverScale;
      const originY = (cy - this.coverTranslateY) / this.coverScale;
      if (
        originX < 0 ||
        originY < 0 ||
        originX > img.width ||
        originY > img.height
      ) {
        return;
      }
      const targetType = this.currentMarkType;
      // 查找当前类型是否已经存在点
      const existIndex = this.coverMarkList.findIndex(
        (item) => item.type === targetType
      );
      const newPoint = {
        x: Math.round(originX),
        y: Math.round(originY),
        type: targetType,
      };
      if (existIndex > -1) {
        // 同类型已有点位，直接覆盖坐标
        this.coverMarkList.splice(existIndex, 1, newPoint);
      } else {
        // 该类型无点位，新增
        this.coverMarkList.push(newPoint);
      }
      this.drawCoverCanvas();
    },
    // 删除单个标记
    removeSingleMark(index) {
      this.coverMarkList.splice(index, 1);
      this.drawCoverCanvas();
    },
    clearCoverMarks() {
      this.coverMarkList = [];
      this.drawCoverCanvas();
    },
    clearCanvasInstance() {
      if (this.coverCanvas) {
        this.coverCanvas.onwheel = null;
        this.coverCanvas.onmousedown = null;
        this.coverCanvas.onmousemove = null;
        this.coverCanvas.onmouseup = null;
        this.coverCanvas.onmouseleave = null;
        this.coverCanvas = null;
        this.coverCtx = null;
      }
      this.coverImgObj = null;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./user-product-launch.scss";
.img-item:active {
  opacity: 0.6;
}
.img-show-wrap {
  display: flex;
  gap: 8px;
}
.add-btn {
  flex-shrink: 0;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  label {
    width: 74px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
  }
  input,
  ::v-deep .el-select {
    height: 32px;
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
  }
}
// 单独一行的表单项（样衣编号、品名/编号）
.single-item {
  width: 100%;
}
// 面料信息分组
.fabric-group {
  margin-top: 56px;
  .group-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
// 两行两列的行容器
.form-row {
  display: flex;
  .form-item {
    flex: 1;
    margin-bottom: 15px;
  }
}
// 全局加载遮罩层样式
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.publish-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.8;
}
// ========== 复制第二套组件图片hover遮罩样式 ==========
.upload-box {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  .uploaded-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img-mask-edit {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 24px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    z-index: 1;
    .mask-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    }
    .edit-tip-text {
      color: #fff;
      font-size: 13px;
      margin-top: 4px;
    }
  }
  &:hover .img-mask-edit {
    opacity: 1;
  }
  .img-delete-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    z-index: 2;
  }
}
.canvas-wrap {
  canvas {
    cursor: crosshair;
    display: block;
  }
}

/* 删除原来自定义preview‑mask相关css，其余样式全部保留 */
</style>
